import { fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { getCurrentFrontend } from '@/ui-kit/utils';
import { LiberSaveFrontend } from '@/bo-kit/types';
import { AUTH_ROUTES } from '@/routes/consts';

const baseQueryInner = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_GATEWAY_URL,
    credentials: 'include',
});

export const baseQuery: ReturnType<typeof fetchBaseQuery> = async (args, api, extraOptions) => {
    const result = await baseQueryInner(args, api, extraOptions);

    if (result.error) {
        const error = result.error as FetchBaseQueryError;
        if (error.status === 401 || error.status === 403) {
            const isAuthRoute = AUTH_ROUTES.some((route) =>
                window.location.pathname.includes(route)
            );
            if (!isAuthRoute) {
                const frontendType = getCurrentFrontend();
                if (frontendType === LiberSaveFrontend.AUTH) {
                    window.location.href = '/auth';
                } else {
                    window.location.href = `/${frontendType}/auth`;
                }
            }
        }
    }
    return result;
};
